import React from "react";
import {
    Grid,
} from "@material-ui/core";

import {makeStyles} from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import {useFormik} from "formik";
import {Typography} from "@mui/material";
import Container from "@material-ui/core/Container";

const useStyles = makeStyles((theme)=>({
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: "center",
        marginBottom: 10,
        justifyContent:'center',
        minHeight:'85vh',
    },
    title: {
        background: 'linear-gradient(to right, #6A8EC9 10%, #8C74A7 35%, #D44C71 59%, #C91C6E 100%)',
        color: 'transparent',
        backgroundClip: 'text',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        fontWeight: '500 !important',
        textAlign: 'center',
        fontSize: '45px !important',
        [theme.breakpoints.down('sm')]: {
            fontSize: '35px !important',
        },
    },
    actionButton: {
        background: "linear-gradient(to bottom, #E7466E 35%, #FFAC46 190%) !important",
        color: '#fff',
        borderRadius: '20px !important',
        fontSize: '15px !important',
        padding: '6px 12px',
        marginRight: theme.spacing(1),
        '&:hover': {
            background: "linear-gradient(to bottom, #E7466E 35%, #FFAC46 190%) !important",        },
        [theme.breakpoints.down('sm')]: {
            padding: '15px 53px',
            borderRadius: '13px',
        },

    },
    form: {
        width: '900px',
        margin: '0 auto',
        display:'flex',
        flexDirection:'column',
        alignItems:'center',
        justifyContent:'center',
        [theme.breakpoints.down('sm')]: {
            width: '350px',
        },
    },
}));

const validateEmail = (email) => {
    let error;
    if (!email) {
        error = 'Required';
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(email)) {
        error = 'Invalid email address';
    }
    return error;
};

const ContactUs = ({ data, actions, options }) => {
    const classes = useStyles();
    const { } = data;
    const { onSubmitAction } = actions;
    const { } = options;

    const formik = useFormik({
        initialValues: {
            name: '',
            email: '',
            message: ''
        },
        validate: values => {
            const errors = {};
            const emailError = validateEmail(values.email);
            if (emailError) {
                errors.email = emailError;
            }
            return errors;
        },
        onSubmit: (values) => {
            if(onSubmitAction) {
                onSubmitAction(values);
            }
        }
    });


    return (
        <Container className={classes.container}>
            <Typography variant="h5" sx={{ textAlign: "center", marginBottom: 4, marginTop:{xs:'55px', sm:'40px'} }} className={classes.title}>
                Have any issue or need something answered?
            </Typography>
                <form className={classes.form} noValidate onSubmit={formik.handleSubmit}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <TextField
                                style={{backgroundColor:'#fff'}}
                                variant="outlined"
                                required
                                fullWidth
                                name="name"
                                label="Name"
                                type="text"
                                id="name"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.name}
                                error={formik.touched.name && Boolean(formik.errors.name)}
                                helperText={formik.touched.name && formik.errors.name}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                style={{backgroundColor:'#fff'}}
                                variant="outlined"
                                required
                                fullWidth
                                name="email"
                                label="Email"
                                type="email"
                                id="email"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.email}
                                error={formik.touched.email && Boolean(formik.errors.email)}
                                helperText={formik.touched.email && formik.errors.email}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                style={{backgroundColor:'#fff'}}
                                variant="outlined"
                                required
                                fullWidth
                                name="message"
                                label="Message"
                                type="text"
                                multiline
                                rows={6}
                                id="message"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.message}
                                error={formik.touched.message && Boolean(formik.errors.message)}
                                helperText={formik.touched.message && formik.errors.message}
                            />
                        </Grid>
                    </Grid>
                    <Button
                        style={{
                            marginTop: 24,
                            width: '20%'
                        }}
                        type="submit"
                        fullWidth
                        variant="contained"
                        color="primary"
                        className={classes.actionButton}
                        disabled={formik.isSubmitting}
                    >
                        Submit
                    </Button>
                </form>
        </Container>
    );
}
export default ContactUs;